export const IconEmail = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<g fill="none" fillRule="evenodd" transform="translate(0 2)">
				<rect width="16" height="12" x="2" y="2" rx="2" />
				<path
					fill="#7F829C"
					fillRule="nonzero"
					d="M16,0 C18.209139,0 20,1.790861 20,4 L20,12 C20,14.209139 18.209139,16 16,16 L4,16 C1.790861,16 0,14.209139 0,12 L0,4 C0,1.790861 1.790861,0 4,0 L16,0 Z M16,2 L4,2 C2.8954305,2 2,2.8954305 2,4 L2,12 C2,13.1045695 2.8954305,14 4,14 L16,14 C17.1045695,14 18,13.1045695 18,12 L18,4 C18,2.8954305 17.1045695,2 16,2 Z"
				/>
				<path
					fill="#7F829C"
					fillRule="nonzero"
					d="M1.47019987,1.56715627 C1.83303152,1.15077707 2.46470672,1.10736821 2.88108592,1.47019987 L10.0001211,7.67312109 L17.0998852,1.48924625 C17.4842958,1.15439415 18.0520912,1.16572095 18.4224875,1.49698997 L18.5107538,1.5864575 C18.8735102,2.00290223 18.8299872,2.63456958 18.4135425,2.99732602 L10.6568286,9.75403989 C10.2802936,10.0820318 9.71951095,10.0819812 9.34303517,9.75392123 L1.56715627,2.97804232 C1.15077707,2.61521067 1.10736821,1.98353546 1.47019987,1.56715627 Z"
				/>
			</g>
		</svg>
	);
};
